import React, { useState } from 'react';

const InfoPopup = ({ info }) => {
    // State to control the visibility of the popup
    const [isVisible, setIsVisible] = useState(false);

    // Function to toggle the visibility
    const togglePopup = () => setIsVisible(!isVisible);

    return (
        <div>
            {/* Trigger button */}
            <i className="fa-solid fa-circle-info" onClick={togglePopup} style={{ cursor: 'pointer', marginLeft: '10px', color: 'var(--color-middle-grey)' }}></i>

            {/* Popup */}
            {isVisible && (
                <div style={styles.overlay}>
                    <div style={styles.popup}>
                        <p>{info}</p>
                        {/* Close button */}
                        <button onClick={togglePopup} style={styles.button}>Close</button>
                    </div>
                </div>
            )}
        </div>
    );
};

// Basic styles
const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    popup: {
        backgroundColor: 'var(--color-background)',
        padding: '20px',
        borderRadius: '5px',
        boxShadow: '0 0 6px rgba(255,255,255,0.5)',
    },
    button: {
        marginTop: '10px',
    }
};

export default InfoPopup;
